// extracted by mini-css-extract-plugin
export var blue = "_3m-g";
export var brand = "_3m-c";
export var darkGrey = "_3m-f";
export var disabled = "_3m-6";
export var disabledSubtle = "_3m-7";
export var error = "_3m-8";
export var green = "_3m-h";
export var grey = "_3m-e";
export var icon = "_3m-0";
export var inherit = "_3m-b";
export var lightGrey = "_3m-d";
export var orange = "_3m-j";
export var pink = "_3m-l";
export var primary = "_3m-1";
export var purple = "_3m-m";
export var quaternary = "_3m-4";
export var quinary = "_3m-5";
export var red = "_3m-k";
export var secondary = "_3m-2";
export var success = "_3m-a";
export var tertiary = "_3m-3";
export var warning = "_3m-9";
export var white = "_3m-n";
export var yellow = "_3m-i";